module.exports = __webpack_public_path__ + "media/img/Landing_Page/s2u-landing-scholarships-4c3119f4676329014f857ffdd868ed07.svg";